export const CUSTOMER_CONST = {
CASH_CUSTOMER:2001,
GENERAL_CUSTOMER_TYPE : 2011,
}